import React, { useState, useEffect } from "react";
import axios, { isCancel } from "axios";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from "@mui/material/FormGroup";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import moment from "moment";
import Paper from '@mui/material/Paper';
import RefreshIcon from "@mui/icons-material/Refresh";
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import ListIcon from '@mui/icons-material/List';
import configs, { getParameterByName } from "../Constants";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import MenuList from '@mui/material/MenuList';
import MenuItem from "@mui/material/MenuItem";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import Chip from "@mui/material/Chip";
//import currencySymbol from 'currency-symbol'
import Currencies from "../root/currency";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import "react-responsive-list/assets/index.css";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import DinnerDining from "@mui/icons-material/DinnerDining";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import PrintIcon from "@mui/icons-material/Print";
import BillPrint from "./BillPrint";
import TokenIcon from "@mui/icons-material/Token";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { amber, purple } from "@mui/material/colors";
import { useIntl } from "react-intl";
import PaymentOptions from "./sub_comp/PaymentOptions";
import DatePicker from "react-datepicker"; // Make sure to install react-datepicker
import "react-datepicker/dist/react-datepicker.css"; // Import the styles for the date picker
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import BillPopup from "./sub_comp/BillPopup";
import TempOrder from "./sub_comp/TempOrder";
import AssignDriverPopup from "./sub_comp/AssignDriverPopup"; // adjust path if needed
import AssignWaiterPopup from './sub_comp/AssignWaiterPopup';
import DeleteDiaologue from "./sub_comp/Delete";
import { useNavigate } from "react-router-dom";
import DiscountIcon from '@mui/icons-material/Discount';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import TableChartIcon from '@mui/icons-material/TableChart';
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { printReceipt } from "./util";
const OrderList = (props) => {
  const orderListPath = `/orderList`;
  const [totalOrders, setTotalOrders] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [orderItemsList, setOrderItemsList] = useState([]);
  const [token, setToken] = useState(0);
  const [edit, setEdit] = useState(false);
  const [editQuantity, setEditQuntity] = useState(0);
  const [orderListId, setOrderListId] = useState();
  const [itemName, setItemName] = useState("");
  const [itemId, setItemId] = useState();
  const [alertOpen, setAlertOpen] = useState(false);
  const [notifiData, setNotifiData] = useState([]);
  const [openNotifi, setOpenNotifi] = useState(false);
  const [tabView, setTabView] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [table1Data, setTable1Data] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  let timeOt = null;
  const [orderFilter, setOrderFilter] = useState([]);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const closeModal = () => setPopUpOpen(false);
  const [showProducts, setShowProducts] = useState(true);
  const [waiter, setWaiter] = useState(false);
  const [kitchenView, setKitchenView] = useState(false);
  const [products, setProducts] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [tablecall, setTableCall] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [selectedOrd, setSelectedOrd] = useState([]);
  const [customerorderpop, setCustomerOrderPop] = useState(false);
  const [isReversed, setIsReversed] = useState(true);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [printOrder, setPrintOrder] = useState(null);
  const [startBillPrint, setStartBillPrint] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [payModeSelectDialog, setPayModeSelectDialog] = useState(false);
  const [payModeIndx, setPayModeIndx] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [billPopupOpen, setBillPopupOpen] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [tempOrderView, setTempOrderView] = useState(1);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteitemName, setDeleteItemName] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [tempOrders, setTempOrders] = useState([]);
  const [orderCancel, setOrderCancel] = useState(true);
  const [tableId, setTableId] = useState(null);
  const [OrderId, setOrderId] = useState(null);
  const [openActions, setOpenActions] = useState(false);
  const [assignPopupOpen, setAssignPopupOpen] = useState(false);
  const [selectedOrderForDriver, setSelectedOrderForDriver] = useState(null);
  const [selectedOrderForServer, setSelectedOrderForServer] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState("down"); // Can be 'up' or 'down'
  const [confirmRejectTempOrder, setConfirmRejectTempOrder] = useState(false);
  const [tempOrderToRejectId, setTempOrderToRejectId] = useState(null);
  const [printType, setPrintType] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [kitchens, setKitchens] = useState([]);
  const [members, setMembers] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [viewMode, setViewMode] = useState('card'); // 'card' or 'table'
  const [infoExpanded, setInfoExpanded] = useState({});
  const [orderFilterType, setOrderFilterType] = useState('preparing'); // 'preparing', 'ready'
  const [tempOrderFilterType, setTempOrderFilterType] = useState('now'); // 'now', 'scheduled'
  const [payConfirmDialog, setPayConfirmDialog] = useState(false);
  const [report, setReport] = useState([]);

  const navigate = useNavigate();
  let baseURL = configs.baseURL;
  // let baseURL = "https://inventory-service-gthb.onrender.com";
  let authApi = configs.authapi;
  const theme = createTheme({
    palette: {
      info: amber,
      secondary: purple,
    },
  });
  const handleOrder = () => {
    setShowProducts(false);
  };
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  let merchantData = sessionStorage.getItem("merchantData")
    ? JSON.parse(sessionStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  let userToken = sessionStorage.getItem("token") || "";
  console.log("merch", merchCode);
  const userId = userData ? userData.sub : " ";
  const getOrderList = `${baseURL}/api/orders/recent?merchantCode=${merchCode}`;
  // const getOrderList = `${baseURL}/api/orders/?merchantCode=${merchCode}`;
  const notificationURL = `${baseURL}/menu/notification/${userId}`;
  const deleteNOtificationUrl = `${baseURL}/menu/notifications/${userId}`;
  const getTabByUser = baseURL + "/api/tables?merchantCode=" + merchCode;
  const getProductByUser = baseURL + `/api/products?merchantCode=${merchCode}`;
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData.currency || 'USD'
  });
  //currecny
  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData.currency
  );
  console.log(currency);
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  // console.log(SelectCurrency);
  const selectedCurrency = (
    <span dangerouslySetInnerHTML={{ __html: SelectCurrency }} />
  );


  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await axios.get(`${authApi}/user/members?userid=${userId}`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        });
        console.log(res.data);
        setMembers(res.data || []);
      } catch (err) {
        console.log("Failed to fetch members", err);
        setMembers([]);
      } finally {
        //setLoading(false);
      }
    };
    // const interval = setInterval(() => fetchOrdersAndNoti(), 10*1000);
    // return () => clearInterval(interval);
    fetchMembers();

  }, []);

  useEffect(() => {
    if (!products.length) {
      axios.get(getProductByUser).then((response) => {
        if (response.data.length !== products.length) {
          setProducts(response.data);
          console.log(response.data);
        }
      });
    }
  }, []);
  const encodeQueryData = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
  const fetchKitchens = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/kitchens?merchantCode=${merchCode}`,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );
      console.log("getting", res.data);
      setKitchens(res.data);
    } catch (err) {
      console.error("Error fetching kitchens:", err);
    }
  };

  useEffect(() => {
    fetchKitchens();
  }, []);
  const handleActionsClose = () => {
    setOpenActions(false);
  };


  const fetchTempOrders = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/temporders/?merchantCode=${merchCode}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      setTempOrders(res.data);
    } catch (err) {
      console.log("Failed to fetch orders");
    }
  };

  useEffect(() => {
    fetchTempOrders();
  }, [baseURL, userToken]);


  const handleOpenPopup = (order) => {
    setBillDetails(order);
    console.log("customerId", order.customerId);

    const ordersOnHold = JSON.parse(localStorage.getItem("orderOnHold")) || [];

    const updatedOrders = ordersOnHold.map((o) =>
      o.customerId === order.customerId ? { ...o, isDelivered: true } : o
    );
    localStorage.setItem("orderOnHold", JSON.stringify(updatedOrders));
    setBillPopupOpen(true);
  };

  const handleClosePopup = () => {
    setBillPopupOpen(false);
    setBillDetails(null);
  };

  const handleUpdateOrder = (order) => {
    const merchantInParam = getParameterByName("merchantCode");
    if (merchantInParam) {
      navigate(`/epos/${order.id || selectedOrder.id}?merchantCode=${merchCode}`);
    } else {
      navigate(`/epos/${order.id || selectedOrder.id}`);
    }
  }

  const orderListHandler = (orderId, customerId, order) => {

    setToken(order.number);
    setIsOpen(true);

    const SelectedorderItem = orderList.length
      ? orderList.filter((order) => order.id === orderId)
      : [];
    setSelectedOrd(SelectedorderItem);
    console.log(SelectedorderItem);

    axios
      .get(`${baseURL}/api/orders/${orderId}?merchantCode=${merchCode}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.orderItems) {
          setOrderItemsList(res.data.orderItems);
        } else {
          setOrderItemsList(res.data);
        }
      });

    if (customerId) {
      console.log(customerId);
      axios
        .get(`${authApi}/customer/${customerId}`)
        .then((response) => {
          console.log(response.data);
          if (!response.data) {
            response.data = {};
          }
          setCustomerData(response.data);
          setCustomerOrderPop(true);
          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    console.log(SelectedorderItem);
  };

  const tempOrderListHandler = (orderId, customerId, order) => {
    console.log("order", order);
    setIsOpen(true);
    setToken(order.token || 0);
    setSelectedOrd([order]);
    setOrderItemsList(order.orderItems || []);

    //  If customerId is present, fetch from API (like in normal order)
    if (customerId) {
      axios
        .get(`${authApi}/customer/${customerId}`)
        .then((response) => {
          setCustomerData(response.data || {});
          setCustomerOrderPop(true);
        })
        .catch((err) => {
          console.log("Customer fetch error", err);
          setCustomerData({
            firstName: order.customerName || "N/A",
            phone: order.customerPhone || "N/A",
            address: order.customerAddress || "N/A",
          });
          setCustomerOrderPop(true);
        });
    } else {
      // If customerId is missing, fallback to available order fields
      setCustomerData({
        firstName: order.customerName || "N/A",
        phone: order.customerPhone || "N/A",
        address: order.customerAddress || "N/A",
      });
      setCustomerOrderPop(true);
    }
  };

  const handleClose = () => {
    setOrderItemsList([]);
    setIsOpen(false);
    setCustomerData([]);
    setCustomerOrderPop(false);
  };



  const handleOrderStatus = (order_Status, order_id, order_payment, order) => {
    console.log(order_id, order_payment);

    const SelectedorderItem = orderList.length
      ? orderList.filter((o) => o.id === order_id)
      : [];
    console.log(SelectedorderItem);
    setSelectedOrd(SelectedorderItem);

    const isTableOrder = order?.orderType === "Table Order";

    if (
      order_Status.toLowerCase() === "ready" ||
      order_Status.toLowerCase() === "deliver"
    ) {
      if (isTableOrder || order_payment) {
        console.log(order_payment);
        axios
          .patch(`${baseURL}/api/orders/${order_id}?merchantCode=${merchCode}`, {
            action: order_Status,
          })
          .then((response) => {
            console.log("response data", response.data);
            let today = new Date();
            console.log(moment(today).format("DD/MMM/YYYY"));
            axios.get(getOrderList).then((response) => {
              console.log("order list", response.data);
              setOrderList(response.data);
            });

            if (order && order_Status.toLowerCase() === "ready") {
              HandleReady([order]);
            } else if (order && order_Status.toLowerCase() === "deliver") {
              HandleServed([order]);
            }
          });
      } else {
        setAlertOpen(true);
      }
    } else if (order_Status.toLowerCase() === "new" && isTableOrder) {
      // If orderStatus is NEW and orderType is Table Order, proceed to next step
      console.log("Table Order with NEW status, proceeding...");

      axios.get(getOrderList).then((response) => {
        console.log("order list", response.data);
        setOrderList(response.data);
      });
    } else {
      // axios
      //   .delete(`${baseURL}/api/orders/${order_id}?merchantCode=${merchCode}`, {
      //     action: orderStatus,
      //   })
      //   .then((response) => {
      //     console.log(response.data);
      //     let today = new Date();
      //     console.log(moment(today).format("DD/MMM/YYYY"));
      //     axios.get(getOrderList).then((response) => {
      //       console.log("response for orders", response.data);
      //       setOrderList(response.data);
      //     });
      //   });
      // console.log(orderStatus);
      setDeleteItemId(order_id);
      setOrderStatus(order_Status);
      setOpenDeleteDialog(true);
    }
  };

  console.log("orderlist for checking", orderList);

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const event_handler3 = (event) => {
    try {
      console.info('EVENT: Received event refund-----');

      var data;
      data = event.data;
      console.log(data);

      if (data && typeof data == 'string' && (JSON.parse(data)?.result == "FAILURE" || JSON.parse(data)?.result == "CANCELLED" || JSON.parse(data)?.result == "NOCONNECTION" || JSON.parse(data)?.result == "SUCCESS")) {
        setPayConfirmDialog(false);
      }

    }
    catch (e) {
      console.log(e);
    }
  }



  useEffect(() => {
    if (userData?.paymentProviderType?.toLowerCase() == 'verifone') {
      window.addEventListener('message', (event) => event_handler3(event, setPayConfirmDialog), false);
    }
  }, []);

  const handleConfirmDelete = () => {
    if (!deleteItemId) {
      return;
    }
    axios
      .delete(
        `${baseURL}/api/orders/${deleteItemId}?merchantCode=${merchCode}`,
        {
          action: orderStatus,
        }
      )
      .then((response) => {
        console.log(response.data);
        let today = new Date();
        console.log(moment(today).format("DD/MMM/YYYY"));
        axios.get(getOrderList).then((response) => {
          setOrderList(response.data);
        });
      });
    console.log(orderStatus);

    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleCancel = async (order_id, order_cancel, tableId, orderNum) => {
    setOrderId(order_id);
    setOrderCancel(order_cancel);
    setTableId(tableId);
    setDeleteItemName(`Order Token/Table#: ${orderNum}`);
    setOpenDeleteDialog(true);
  };

  const handleCancelClose = () => {
    setOrderId(null);
    setOrderCancel("");
    setTableId(null);
    setOpenDeleteDialog(false);
  };

  const handleConfirmCancel = async () => {
    try {
      await axios.patch(
        `${baseURL}/api/orders/${OrderId}?merchantCode=${merchCode}`,
        {
          action: "cancel",
        }
      );
      if (tableId) {
        await axios.patch(
          `${baseURL}/api/tables/${tableId}/availability?merchantCode=${merchCode}`
        );
      }
      fetchOrdersAndNoti();
    } catch (error) {
      console.error("Error while cancelling order or updating table:", error);
    }
    setOrderId(null);
    setOrderCancel(true);
    setTableId(null);
    setOpenDeleteDialog(false);
    if (userData.paymentProviderType.toLowerCase() == 'verifone') {
      let ord = orderList.filter(or => or._id == OrderId);
      refund_tx(ord?.[0]?.paymentRefData);
    }

  };

  const handlePayment = (mode) => {
    if (selectedOrder && selectedOrder.id) {
      axios
        .patch(`${baseURL}/api/orders/${selectedOrder.id}?merchantCode=${merchCode}`, {
          paymentState: "PAID",
          isPaid: true,
          payVia: mode,
        })
        .then((response) => {
          console.log(response);
          let today = new Date();
          axios.get(getOrderList).then((response) => {
            setOrderList(response.data);
          });
        });
    }


    if (selectedOrder?.orderType.toUpperCase() == "TABLE ORDER") {
      const tabData = tableData.filter((tab) => tab.number == selectedOrder?.number);
      if (tabData.length > 0) {
        axios
          .patch(
            `${baseURL}/api/tables/${tabData[0].id}/availability/?merchantCode=${merchantData ? merchantData.merchantCode : " "
            }`
          )
          .then((res) => {
            console.log(res.data);
          });
      }
    }
  };

  const handleEdit = (itemId) => {
    console.log(itemId);
    const itmName =
      orderItemsList.length &&
      orderItemsList.map(
        (o) =>
          o._id === itemId &&
          setItemName(o.name) & setEditQuntity(o.quantity) & setItemId(o._id)
      );
    console.log(itmName);
    setEdit(true);
  };

  const handleInput = (event) => {
    console.log(event.target.value);
    setEditQuntity(event.target.value);
  };

  const habdleSubmit = (event) => {
    event.preventDefault();
    console.log(editQuantity);

    const updateItems = orderItemsList.map((ordListItem) => {
      if (ordListItem._id === itemId) {
        ordListItem.quantity = editQuantity;
        //ordListItem.price= ordListItem
      }
      return ordListItem;
    });
    console.log(updateItems);

    axios
      .patch(baseURL + "/api/orders/" + orderListId, { orderItems: updateItems })
      .then((res) => {
        console.log(res.data);
        let today = new Date();
        console.log(moment(today).format("DD/MMM/YYYY"));
        axios.get(getOrderList).then((response) => {
          //setTotalOrders(response.data);
          setOrderList(response.data);
        });
      });
    const updatePrice = orderItemsList.filter((oli) => oli._id === itemId);
    const ordPrice = orderList.filter((ol) => ol._id === orderListId);
    console.log(updatePrice[0].price, editQuantity, ordPrice[0].totalPrice);
    setEdit(false);
  };

  const HandleServed = (order, itemId) => {
    console.log(order);
    console.log(itemId);
    if (order) {
      let updatedOrderItems = order[0].orderItems.map((ord) => {
        console.log(ord._id);
        console.log(itemId);
        {
          if (ord._id === itemId || !itemId) {
            console.log("Updated");
            ord.status = "delivered";
          }
          return ord;
        }
      });
      order[0].orderStatus = "Delivered";
      console.log(order[0].orderItems);
      setOrderItemsList(updatedOrderItems);
      axios.patch(baseURL + "/api/orders/" + order[0].id, {
        orderItems: updatedOrderItems,
      });
    }
  };

  const HandleReady = (order, itemId) => {
    console.log(order);
    console.log(itemId);
    if (order) {
      let updatedOrderItems = order[0].orderItems.map((ord) => {
        if (ord._id === itemId || !itemId) {
          ord.status = "ready";
        }
        return ord;
      });
      setOrderItemsList(updatedOrderItems);
      axios.patch(baseURL + "/api/orders/" + order[0].id, {
        orderItems: updatedOrderItems,
      });
    }
  };

  const handleDelete = (name, price, quantity, itemId) => {
    console.log(itemId);
    setDeleteItemName(name);
    setDeleteItemId(itemId);
    setOpenDeleteDialog(true);
  };

  const fetchOrdersAndNoti = () => {
    let today = new Date();
    console.log(moment(today).format("DD/MMM/YYYY"));
    axios.get(getOrderList).then((response) => {
      //setTotalOrders(response.data);
      setOrderList(response.data);
    });

    // axios.get(notificationURL).then((response)=>{
    //     setNotifiData(response.data);
    // });
    console.log(props.refesh);

    axios.get(getTabByUser).then((response) => {
      console.log(response.data);
      setTableData(response.data);
    });
  };

  const fetchOrdersByDate = (date) => {
    if (!date) return;
    const fromDate = moment(date).startOf('day').format("YYYY-MM-DD");
    const toDate = moment(date).endOf('day').format("YYYY-MM-DD");

    console.log("Fetching for date:", fromDate);

    axios
      .get(
        `${baseURL}/api/orders/recent?merchantCode=${merchCode}`
      )
      .then((res) => {
        let recents = res.data.filter((item) => {
          const itemTime = new Date(item.updatedAt).getTime();
          const fromTime = new Date(fromDate).getTime();
          const toTime = new Date(toDate).getTime() + 86400000;
          return itemTime >= fromTime && itemTime < toTime;
        });
        console.log("recents", recents);
        axios
          .get(
            `${baseURL}/api/orders/report/${merchCode}?start_date=${fromDate}&end_date=${toDate}`
          )
          .then((response) => {
            console.log("report data", response.data);
            setReport([...recents, ...response.data]);
          })
          .catch((error) => {
            console.error("Error fetching report data:", error);
          });
      });
  };

  useEffect(() => {
    if (selectedDate) {
      fetchOrdersByDate(selectedDate);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchOrdersAndNoti();
  }, [props.refesh]);



  const handleRefresh = () => {
    console.log("API CALLED");
    setReport([]);
    setSelectedDate(new Date());
    fetchOrdersAndNoti();
    fetchTempOrders();
  };

  const handleNotification = () => {
    axios.get(notificationURL).then((response) => {
      console.log(response.data);
      setNotifiData(response.data);
    });
    setOpenNotifi(true);
  };

  const handleClear = () => {
    console.log("Clear All Data");
    axios.delete(deleteNOtificationUrl).then((response) => {
      console.log(response.data);
      // setNotifiData(response.data);
      setOpenNotifi(false);
      props.setNotification(false);
    });
  };

  const handleTableOrders = () => {
    setTabView(tabView ? false : true);
  };

  const handleTypeOrder = (e) => {
    let val = e.target.value;
    console.log(val);
    let fltOrder = orderList.filter((ord) => ord.orderType == val);
    console.log(fltOrder);
    setOrderFilter(fltOrder);
    setIsSearch(val ? true : false);
  };

  const handlecheckprintKOT = (order) => {
    try {
      const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
        style: 'currency',
        currency: merchantData?.currency || 'USD'
      });
      order['tokenNo'] = "Token #" + order.number;
      order["header1"] = t({ id: "items" });
      order["header2"] = t({ id: "quantity" });
      order["header3"] = t({ id: "amountlbl" });
      order["invoiceNo"] = t({ id: "invoice" }) + "#:" + order.invoice_no;
      order["date"] = moment(order.createdAt).format(
        "DD-MMM-YYYY h:mm a"
      );
      order.orderItems = [];
      //let kitchensUsed =[];
      let AddorderItems =
        order &&
        order.orderItems &&
        order.orderItems.map((item, index) => {
          const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
          const addonNames = subPro.addons
            ?.map((a) => a.name)
            .join(", ");
          const varietyNames = subPro.variety
            ? Object.keys(subPro.variety).join(", ")
            : "";
          const cookInst = subPro.cookInstructions.join(',');
          item.price = formatter.format(item.price).replace('JMD', 'J$').replace(/\s+/, "");
          item.quantity = item.select_type === "weight"
            ? `${(item.quantity / 1000).toFixed(2)}K/L `
            : item.quantity;
          item.addOnsStr = addonNames;
          item.varNames = varietyNames;
          item.notes = cookInst;
          // if(item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1){
          //     kitchensUsed.push(item.kitchenId);
          // }
          order.orderItems.push(item);
        });

      printKOT(order); // Set the order too
      //setInvoiceNo(response.data.invoicePath);
    } catch (error) {
      //setPrintOrder(order);
      console.error("Error calling order API:", error);
    }
  };

  const handlecheckprint = async (order) => {
    try {
      const url = order.invoiceId
        ? `${configs.payUrl}/api/invoices/${order.invoiceId}`
        : `${configs.payUrl}/api/proforma-invoices/${order.id}`;

      const response = await axios.get(url);

      setPrintType('receipt');
      setInvoiceNo(response.data.invoicePath);
      handlePrint(order);
    } catch (error) {
      setPrintType('receipt');
      setInvoiceNo("" + new Date().getTime());
      setPrintOrder(order);
      //console.error("Error calling order API:", error);
    }
  };

  // ⏬ This useEffect will run once invoiceNo is set
  useEffect(() => {
    if (printOrder) {

      handlePrint(printOrder);

    }
  }, [printOrder]);

  const getOrderPrintDetails = () => {
    let orderDet = printOrder;
    console.log(orderDet);
    let orderData = {
      orderId: orderDet ? (orderDet._id || orderDet.id) : "",
      merchantCode: merchCode ? merchCode : "",
      currency: currency.length && currency[0].abbreviation,
      restaurant: merchantData?.firstName || "",
      address:
        userData || merchantData
          ? merchantData.address || userData.address
          : "",
      cgst: merchantData.taxPerc,
      taxPerc: merchantData.taxPerc,
      receiptNote: merchantData.receiptNotes || "",
      cashier: userData ? userData.name : "",
      invoice_no: invoiceNo ? invoiceNo : "-",
      printType: printType,
      kitchens: kitchens,
      logoImg: merchantData.logoImg
    };

    if (orderDet.orderType == "Table Order" && merchantData?.dining_service_charge) {
      orderData['serviceCharge'] = merchantData.dining_service_charge;
    }
    return { ...orderDet, ...orderData };
  }

  const printKOT = (order) => {

    let printDetails = JSON.parse(JSON.stringify(order));
    console.log(printDetails);
    let kitchensUsed = [];
    let filterKitchenUsed = order?.orderItems.map((item, index) => {
      if (item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1) {
        kitchensUsed.push(item.kitchenId);
      }
    });

    if (kitchensUsed.length) {
      let kitchPrintIndx = 0;
      let kitchPrintTimer = null;

      function sendForKOTPrint() {
        if (kitchPrintIndx >= kitchensUsed.length) {
          clearTimeout(kitchPrintTimer);
          kitchPrintIndx = 0; // Reset for next time (optional)
          return;
        }

        printDetails.printType = "KOT";
        window.PrintInterface.print(JSON.stringify(printDetails));

        kitchPrintIndx++;
        kitchPrintTimer = setTimeout(sendForKOTPrint, 15 * 1000);
      }

      sendForKOTPrint();
    } else {
      printDetails.printType = "KOT";
      window.PrintInterface.print(JSON.stringify(printDetails));
    }

  }

  const handlePrint = (order) => {
    if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
      //if (true) {
      let ord = getOrderPrintDetails();
      ord.receiptNote = merchantData.receiptNotes || "";
      ord.cashOut = ord.cashOut || 0;
      ord.isPaid = ord.isPaid || "Unpaid";
      ord.customer = ord.customerInfo ? ("Name: " + ord.customerInfo.name + " Phone: " + ord.customerInfo.phone + " Email: " + ord.customerInfo.email + " Address: " + ord.customerInfo.address) : "";
      console.log(ord);
      printReceipt(ord, merchantData, [], t, formatter);
      //if(true){
      // setStartBillPrint(true);
      // localStorage.setItem("isPrintCall", "N");
    } else {
      sessionStorage.setItem("billing", true);
      summaryPath1(order);
    }
  };

  function summaryPath1(orderDetails) {
    console.log(orderDetails);
    const fullName = merchantData?.firstName || userData?.name || "";

    if (orderDetails) {
      window.location.href = `${window.location.origin
        }/billPrint?serve_url=${baseURL}&orderId=${orderDetails ? orderDetails.id : ""
        }&merchantCode=${merchCode ? merchCode : ""}&currency=${currency.length && currency[0].abbreviation
        }&restaurant=${fullName}&address=${userData || merchantData ? merchantData.address || userData.address : ""
        }&cgst=${merchantData.taxPerc}&invoice_no=${invoiceNo}&printType=${orderDetails.printType || "Order"
        }`;
    }
  }

  const handleNumberSearch = (e) => {
    let val = e.target.value;
    console.log(val);
    let fltOrder = orderList.filter((ord) => ord.number === parseInt(val));
    console.log(fltOrder);
    setOrderFilter(fltOrder);
    setIsSearch(val ? true : false);
  };

  const handleDate = (e) => {
    let val = e.target.value;

    let inputDate = moment(val, "YYYY-MM-DD");

    let fltOrder = totalOrders.filter((ord) => {
      let orderDate = moment(ord.createdAt).format("DD/MMM/YYYY");
      console.log(orderDate);
      console.log(inputDate.format("DD/MMM/YYYY"));
      return orderDate === inputDate.format("DD/MMM/YYYY");
    });

    setOrderFilter(fltOrder);
    setIsSearch(Boolean(val));
  };

  // useEffect(() => {
  //    setInterval(() => {
  //     fetchOrdersAndNoti();
  //   }, 120*1000);


  // }, []);

  // console.log("orderFilter" , orderFilter);
  console.log("orderList", orderList);
  const ListOrders = isSearch ? orderFilter : (report.length ? report : orderList);
  console.log("listOrders", ListOrders);

  // console.log(orderList);

  //  const orderSTATS =  orderList.filter(cosdata => cosdata.customerId === customerData.user.id)
  // console.log(orderSTATS)
  console.log(customerData);
  const handleSort = () => {
    setIsReversed(!isReversed);
  };

  const handleWaiterToken = () => {
    setWaiter(true);
  };

  const handleWaiterClose = () => {
    setWaiter(false);
    setKitchenView(false);
    fetchOrdersAndNoti();
    fetchTempOrders();
  };
  const iframeSrc = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/waiter-token/tokens.html?serve_url=${baseURL}&merchantCode=${merchCode}`;

  const kitchenSrc = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/kitchen-side-token/tokens.html?serve_url=${baseURL}&merchantCode=${merchCode}`;
  const filteredOrders = [...ListOrders];
  // Function to filter orders based on the selected date
  // const filteredOrders = ListOrders.filter((order) => {
  //   const dateToCompare = order.scheduleDate || order.createdAt;
  //   return (
  //     moment(dateToCompare).isSame(moment(selectedDate), "day") &&
  //     order.orderStatus?.toUpperCase() !== "REJECTED"
  //   );
  // });


  const acceptOrder = async (orderId) => {
    console.log("id for temp", orderId);
    try {
      const res = await axios.put(
        `${baseURL}/api/temporders/${orderId}`,
        { orderStatus: "ACCEPTED" },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("Order accepted");
      fetchTempOrders();
      fetchOrdersAndNoti();
    } catch (err) {
      console.error("Failed to accept order", err);
    }
  };

  const rejectOrder = async (orderId) => {
    console.log("id for temp", orderId);
    try {
      const res = await axios.put(
        `${baseURL}/api/temporders/${orderId}`,
        { orderStatus: "REJECTED" },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("Order rejected:");
      fetchTempOrders();
      fetchOrdersAndNoti();
    } catch (err) {
      console.error("Failed to reject order", err);
    }
  };

  const handleAssignDriverClick = (order) => {
    setSelectedOrderForDriver(order);
    setAssignPopupOpen(true);
  };

  const handleAssignServerClick = (order) => {
    setSelectedOrderForServer(order);
    setAssignPopupOpen(true);
  };

  const refund_tx = (payRefData) => {
    let transData = JSON.parse(payRefData);
    const merchantId = transData.userId;
    var refID = transData.reference_id;
    var amount = transData.total_amount;
    var regID = userData.firstName || userData.name;
    var merchID = merchantId;

    let data = { 'amount': amount, 'reference_id': refID, 'register_id': regID, 'merchant_id': merchID, pos_prints_receipt: true, cash_amount: transData.cash_amount };
    let queryStr = encodeQueryData(data);

    setPayConfirmDialog('https://vcloud.alt-payment.com/webint/refund/NextOrder?' + queryStr);
    // $('#myModal').modal('show');
  }

  const handleWaiterAssign = (waiter) => {
    axios.patch(`${baseURL}/api/orders/${selectedOrderForServer?.id}?merchantCode=${merchCode}`, {
      servedByMemeberId: waiter.id,
    });
    setSelectedOrderForServer(null);
    setAssignPopupOpen(false);
  }

  const handleDriverAssign = async (driver) => {
    console.log("Assigning Driver:", driver);
    console.log("to Order:", selectedOrderForDriver);

    const orderId = selectedOrderForDriver?.id;
    const merchantCode = merchCode;
    const deliveryPartnerId = driver.id;
    const deliveryPartnerCode = "RESTAURANT_OWN";
    console.log("driver", deliveryPartnerId, deliveryPartnerCode);
    const pickupAddress = { address: merchantData.address, location: merchantData.location, name: merchantData.firstName };
    try {
      //create driver details if not available
      //add api call here
      const createDriverResponse = await axios.post(
        `${baseURL}/api/delivery-drivers?merchantCode=${merchantCode}`,
        {
          userId: deliveryPartnerId,
          merchantCode: merchantCode,
          name: driver.firstName,
          phone: driver.phone,
          email: driver.email,
          vehicleType: "",
          vehicleNumber: "",
          isActive: true,
          isAvailable: true,
          currentLocation: { type: "Point", coordinates: [0.0, 0.0] },
          rating: 1,
          deliveryPartnerCode: "RESTAURANT_OWN",
          deviceToken: "",
          documents: []
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );


      //link order and delivery
      const createDeliveryResponse = await axios.post(
        `${baseURL}/api/orders/${orderId}/delivery?merchantCode=${merchantCode}`,
        {

        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const deliveryId = createDeliveryResponse.data.id;
      console.log("Delivery created:", deliveryId);

      const assignDriverResponse = await axios.post(
        `${baseURL}/api/deliveries/${deliveryId}/assign`,
        {
          orderDeliveryId: deliveryId,
          driverId: createDriverResponse.data.id,
          status: "ASSIGNED",
          notes: `Assigned at ${new Date().toISOString()}`,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Driver assigned:", assignDriverResponse.data);

      axios.patch(`${baseURL}/api/orders/${selectedOrderForDriver?.id}?merchantCode=${merchCode}`, {
        orderStatus: "ASSIGNED",
      });
      setAssignPopupOpen(false);
    } catch (error) {
      console.error("Error assigning driver:", error?.response?.data || error.message);
      // console.(
      //   "Driver assignment failed: " +
      //   (error?.response?.data?.message || error.message)
      // );
    }
  };

  return (
    <div className="container" style={{ padding: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          alignItems: "center",
          flexWrap: "wrap",
          '@media (max-width: 768px)': {
            gap: "12px",
            justifyContent: "flex-start"
          },
          '@media (max-width: 480px)': {
            gap: "8px"
          }
        }}
      >
        {/* Search Button */}
        <IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          onClick={() => setSearchShow(!searchShow)}
          style={{
            height: "50px",
            width: "50px",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <SearchIcon
            style={{
              '@media (max-width: 480px)': {
                fontSize: "20px"
              }
            }}
          />
        </IconButton>

        {/* Search Input */}
        {searchShow && (
          <input
            type="text"
            className="search_input"
            onChange={handleNumberSearch}
            placeholder="Search"
            style={{
              borderBottom: "1px solid #000",
              '@media (max-width: 768px)': {
                flex: "1",
                minWidth: "150px"
              },
              '@media (max-width: 480px)': {
                minWidth: "120px",
                fontSize: "14px"
              }
            }}
          />
        )}

        {/* Date Picker */}
        {<IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          style={{
            height: "50px",
            width: "50px",
            position: "relative",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <CalendarTodayIcon
            className="icon"
            style={{
              fontSize: "1.5em",
              '@media (max-width: 480px)': {
                fontSize: "1.3em"
              }
            }}
          />
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <span style={{
                marginLeft: '-35px',
                fontSize: "16px",
                '@media (max-width: 480px)': {
                  fontSize: "14px",
                  marginLeft: '-30px'
                }
              }}>
                {selectedDate ? moment(selectedDate).format("DD") : ""}
              </span>
            }
          />
        </IconButton>}

        {/* Kitchen View Button */}
        {merchantData?.bizVertical === 'restaurant' && (
          <IconButton
            variant="contained"
            color="success"
            className="refresh_btn"
            onClick={() => setKitchenView(true)}
            style={{
              height: "50px",
              width: "50px",
              '@media (max-width: 768px)': {
                height: "45px",
                width: "45px"
              },
              '@media (max-width: 480px)': {
                height: "40px",
                width: "40px"
              }
            }}
          >
            <img
              src="/images/chef.gif"
              style={{
                width: "35px",
                height: "35px",
                objectFit: "contain",
                '@media (max-width: 480px)': {
                  width: "30px",
                  height: "30px"
                }
              }}
              alt=""
            />
          </IconButton>
        )}

        {/* Waiter Token Button */}
        {merchantData?.bizVertical === 'restaurant' && (
          <IconButton
            variant="contained"
            color="success"
            className="refresh_btn"
            onClick={() => handleWaiterToken()}
            style={{
              height: "50px",
              width: "50px",
              '@media (max-width: 768px)': {
                height: "45px",
                width: "45px"
              },
              '@media (max-width: 480px)': {
                height: "40px",
                width: "40px"
              }
            }}
          >
            <img
              src="/images/waiter.png"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
                '@media (max-width: 480px)': {
                  width: "22px",
                  height: "22px"
                }
              }}
              alt=""
            />
          </IconButton>
        )}

        {/* Refresh Button */}
        <IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          onClick={handleRefresh}
          style={{
            height: "50px",
            width: "50px",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <RefreshIcon
            style={{
              '@media (max-width: 480px)': {
                fontSize: "20px"
              }
            }}
          />
        </IconButton>

        {/* View Toggle Button */}
        <div style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            marginLeft: 'auto'
          }
        }}>
          <button
            onClick={() => setViewMode(viewMode === 'card' ? 'table' : 'card')}
            style={{
              padding: '12px',
              border: '1px solid white',
              background: viewMode === 'card' ? 'white' : 'rgb(61 106 4)',
              color: viewMode === 'card' ? 'rgb(61 106 4)' : 'white',
              borderRadius: '50%',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '40px',
              minHeight: '40px'
            }}
          >
            {viewMode === 'card' ? (
              <ListIcon
                sx={{
                  fontSize: '20px',
                  transition: 'transform 0.3s ease',
                  '@media (max-width: 480px)': {
                    fontSize: '18px'
                  }
                }}
              />
            ) : (
              <ViewModuleIcon
                sx={{
                  fontSize: '20px',
                  transition: 'transform 0.3s ease',
                  '@media (max-width: 480px)': {
                    fontSize: '18px'
                  }
                }}
              />
            )}
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >

          <div
            id="head"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              width: "auto",
            }}
          >
            {false && (
              <div id="group">
                <label htmlFor="">Date: </label>
                <input
                  type="date"
                  onChange={handleDate}
                  style={{
                    outline: "none",
                    borderRadius: "5px",
                    background: "transparent",
                  }}
                />
              </div>
            )}
            {false && (
              <span id="table_group">
                Table orders &nbsp;&nbsp;
                <FormControlLabel
                  control={<Switch color="info" />}
                  onChange={handleTableOrders}
                />{" "}
              </span>
            )}
          </div>
        </div>
      </div>

      {startBillPrint && (
        <BillPrint orderDetails={getOrderPrintDetails()} setBillPrint={setStartBillPrint} />
      )}

      <Dialog open={alertOpen} maxWidth="xs" fullWidth={true}>
        <div className="alert-dialog">
          <h3 className="">{"Payment Pending"}</h3>
          <button
            onClick={() => setAlertOpen(false)}
            className="btn btn-sm btn-primary"
            style={{
              width: "60px",
              padding: "10px 5px",
              margin: "auto",
              height: "40px",
            }}
          >
            OK
          </button>
        </div>
      </Dialog>

      {openDeleteDialog === true ? (
        <DeleteDiaologue
          msg="delete"
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteitemName}
        />
      ) : (
        <div />
      )}

      {openDeleteDialog === true ? (
        <DeleteDiaologue
          msg="Cancel Order"
          open={openDeleteDialog}
          onClose={handleCancelClose}
          onConfirm={handleConfirmCancel}
          itemName={deleteitemName}
        />
      ) : (
        <div />
      )}

      <Dialog
        open={openNotifi || props.notification}
        maxWidth="md"
        fullWidth={true}
      >
        <div className="alert-dialog">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span></span>
            <h3 className="">{"Notification"}</h3>
            <button
              style={{ border: "none", color: "red" }}
              onClick={handleClear}
            >
              Clear All{" "}
            </button>
          </div>
          <div style={{ overflowY: "scroll", height: "400px" }}>
            {notifiData.length
              ? notifiData.map((noti) => {
                return (
                  <div>
                    <p>
                      {noti.msg} on{" "}
                      {moment(`${noti.createdAt}`).format("DD MMM h:mm a")}{" "}
                    </p>
                  </div>
                );
              })
              : ""}
          </div>

          <Button
            variant="contained"
            color="error"
            style={{ float: "right", right: "10px" }}
            onClick={() => {
              setOpenNotifi(false);
              props.setNotification(false);
            }}
          >
            Close{" "}
          </Button>
        </div>
      </Dialog>

      <Dialog open={waiter || kitchenView} onClose={handleWaiterClose} fullScreen={true}>
        {/* <IconButton
          edge="start"
          color="error"
          variant="contained"
          onClick={handleWaiterClose}
          aria-label="close"
          style={{
            position: "fixed",
            right: 10,
            top: 10,
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <Button
          variant="contained"
          color="error"
          style={{ float: "right", marginTop: "5px" }}
          className="btn btn-danger m-2 btn-small"
          onClick={handleWaiterClose}
        >
          Close
        </Button>

        {waiter && <iframe
          src={iframeSrc}
          style={{ width: "100%", height: "100%", border: "none", zIndex: 1 }}
          title="Waiter Token"
        />}
        {
          kitchenView && <iframe
            src={kitchenSrc}
            style={{ width: "100%", height: "100%", border: "none", zIndex: 1 }}
            title="Kitchen Tokens"
          />
        }
      </Dialog>

      <div className="category-list" style={{ padding: "2px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            paddingInline: "5px",
            gap: "5px",
          }}
        >

          {false && <div id="group">
            {false && <label>Group By: </label>}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <label>Order Type</label>
              <select
                onChange={handleTypeOrder}
                style={{
                  outline: "none",
                  borderRadius: "5px",
                  background: "transparent",
                }}
              >
                <option value="">ALL</option>
                <option value="Eat In">Eat In Orders</option>
                <option value="Take Away">Take Away Orders</option>
                <option value="Table Order">Table Orders</option>
                <option value="Delivery">Delivery Orders</option>
              </select>
            </span>
          </div>}
        </div>
        <div>

          {/* Pending Orders */}
          {tempOrders.length > 0 &&
            tempOrders.filter(
              (order) =>
                (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.orderType
            ).length > 0 &&
            <div>
              {/* Temp Order Filter Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '16px',
                overflowX: 'auto',
                paddingBottom: '8px',
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch',
                justifyContent: 'center',
                marginTop: "10px"
              }}>
                <Button
                  variant={tempOrderFilterType === 'now' ? 'contained' : 'outlined'}
                  color="primary"
                  onClick={() => setTempOrderFilterType('now')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  NEW ORDERS
                </Button>
                <Button
                  variant={tempOrderFilterType === 'scheduled' ? 'contained' : 'outlined'}
                  color="info"
                  onClick={() => setTempOrderFilterType('scheduled')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Scheduled
                </Button>
              </div>
              <div className="tempOrder">
                <Table breakPoint={700} className="custom-table">
                  <Thead>
                    <Tr className="table-header">
                      <Th>Merchant</Th>
                      <Th>Order Type</Th>
                      <Th>Source</Th>
                      <Th>Amount(Inc tax)</Th>
                      <Th>Order Items</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {tempOrders
                      .filter(
                        (order) =>
                          (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.orderType
                      )
                      .filter((order) => {
                        if (tempOrderFilterType === 'now' && !order.scheduleDate) return true;
                        if (tempOrderFilterType === 'scheduled') {
                          return order.scheduleDate && moment(order.scheduleDate).isAfter(moment());
                          return true;
                        }

                      })
                      .map((order) => (
                        <Tr key={order.id || order._id} className="table-body-row">
                          <Td>{order.userId}</Td>
                          <Td>
                            {(order.orderType.toLowerCase() === "pick up" ||
                              order.orderType.toLowerCase() === "take away") && (
                                <img
                                  height="40px"
                                  width="40px"
                                  alt=""
                                  src="/images/take-out-2.png"
                                />
                              )}
                            {order.orderType.toLowerCase() === "delivery" && (
                              <img
                                height="40px"
                                width="40px"
                                alt=""
                                src="/images/delivery.png"
                              />
                            )}
                          </Td>
                          <Td>
                            <Chip
                              label={order.orderSource || "Self Order"}
                              color={
                                (order.orderSource || "Self Order") === "EPOS"
                                  ? "info"
                                  : (order.orderSource || "Self Order") === "Self Order"
                                    ? "warning"
                                    : (order.orderSource || "Self Order") === "Table Order"
                                      ? "secondary"
                                      : (order.orderSource || "Self Order") === "Online Order"
                                        ? "error"
                                        : "default"
                              }
                              style={{
                                marginLeft: "10px",
                                fontSize: "x-small",
                                fontWeight: "bold",
                              }}
                            />
                            <div style={{ fontSize: "12px" }}>
                              {moment(order.scheduleDate || order.createdAt).format("DD-MMM h:mm a")}
                            </div>
                          </Td>
                          <Td>
                            {selectedCurrency}
                            {(order.discountType
                              ? order.discountType === "discount" || order.discountType === "price"
                                ? order.totalPrice - (order.discountAmount || 0)
                                : order.totalPrice - (order.totalPrice * order.discountAmount) / 100
                              : order.totalPrice
                            ).toFixed(2)}
                            {!order.isPaid ? (
                              <Chip
                                label="PENDING"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                  background: "#fdd564",
                                  color: "#6f650e",
                                }}
                              />
                            ) : (
                              <Chip
                                label="✔ PAID"
                                color="success"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                }}
                              />
                            )}
                          </Td>
                          <Td style={{ fontSize: "12px" }}>
                            <button
                              className="btn-icon"
                              onClick={() =>
                                tempOrderListHandler(
                                  order.id || order._id,
                                  order.customerId,
                                  order
                                )
                              }
                            >
                              <ReceiptLongOutlinedIcon />
                            </button>
                          </Td>
                          <Td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                gap: "30px",
                              }}
                            >
                              <Button
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  setTempOrderToRejectId(order.id || order._id);
                                  setConfirmRejectTempOrder(true);
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </Button>
                              <Button
                                variant="contained"
                                color="success"
                                onClick={() => acceptOrder(order.id || order._id)}
                              >
                                Accept
                              </Button>
                            </div>
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                </Table>
              </div>

            </div>
          }

          <br />

          {/* Main Orders */}
          <div >
            {/* Filter Buttons */}
            {merchantData?.bizVertical === 'restaurant' && (
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '20px',
                overflowX: 'auto',
                paddingBottom: '8px',
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch',
                justifyContent: 'center'
              }}>

                <Button
                  variant={orderFilterType === 'preparing' ? 'contained' : 'outlined'}
                  color="warning"
                  onClick={() => setOrderFilterType('preparing')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Preparing
                </Button>
                <Button
                  variant={orderFilterType === 'ready' ? 'contained' : 'outlined'}
                  color="success"
                  onClick={() => setOrderFilterType('ready')}
                  style={{
                    minWidth: '140px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Orders Ready
                </Button>
              </div>
            )}
            {viewMode === 'card' ? (
              // Card View for Main Orders
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                gap: '20px'
              }}>
                {filteredOrders.length ? (
                  (isReversed ? filteredOrders.slice().reverse() : filteredOrders)
                    .filter((orderLists) => {
                      if (orderFilterType === 'all') return true;

                      const totalItems = orderLists.orderItems?.length || 0;
                      const readyItems = orderLists.orderItems?.filter(item =>
                        item.status === "ready" || item.status === "delivered" || item.status === "served"
                      ).length || 0;
                      const allReady = totalItems > 0 && readyItems === totalItems;

                      if (orderFilterType === 'preparing') {
                        return !allReady;
                      }
                      if (orderFilterType === 'ready') {
                        return allReady;
                      }
                      return true;
                    })
                    .map((orderLists) => {
                      let paidStaus = notifiData.filter((nof) => orderLists.number === nof.token);
                      let payStatus = paidStaus.length ? true : false;
                      let tableCall = false;

                      if (orderLists.orderSource === "Table Order") {
                        const table = tableData && tableData.filter((tab) => tab.number == orderLists.number);
                        tableCall = table ? table[0] ? table[0].isServiceCall : "" : "";
                      }

                      // Calculate served/delivered items count
                      const totalItems = orderLists.orderItems?.length || 0;
                      const servedItems = orderLists.orderItems?.filter(item =>
                        item.status === "served" || item.status === "delivered"
                      ).length || 0;
                      const allServed = totalItems > 0 && servedItems === totalItems;


                      return (
                        <div
                          key={orderLists.id}
                          style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '12px',
                            padding: '20px',
                            background: orderLists.isCanceled ? '#fbe3e3cc' : '#fff',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          {/* Top Header Section */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '1px',
                            flexShrink: 0,
                            '@media (max-width: 768px)': {
                              flexDirection: 'column',
                              gap: '12px'
                            }
                          }}>
                            {/* Left Side */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              flex: 1
                            }}>
                              {/* Order Type Icon */}


                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: '2px',

                              }}>
                                {/* Order Number */}
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#4d4a4a',
                                  lineHeight: '1'
                                }}>
                                  #{orderLists.number}
                                  <div>
                                    {orderLists.orderType.toLowerCase() === "eat in" && (
                                      <img
                                        height="35px"
                                        alt="Eat In"
                                        width="35px"
                                        src="/images/eat_in.png"
                                      />
                                    )}
                                    {(orderLists.orderType.toLowerCase() === "take away" ||
                                      orderLists.orderType.toLowerCase() === "pick up") && (
                                        <img
                                          height="35px"
                                          width="35px"
                                          alt="Take Away"
                                          src="/images/take-out-2.png"
                                        />
                                      )}
                                    {orderLists.orderType === "Table Order" && (
                                      <img
                                        height="35px"
                                        width="35px"
                                        alt="Table Order"
                                        src="/images/tableOrder.png"
                                      />
                                    )}
                                    {orderLists.orderType.toLowerCase() === "delivery" && (
                                      <DeliveryDiningIcon style={{
                                        height: "35px",
                                        width: "35px",
                                      }} />
                                    )}
                                  </div>
                                  {tableCall && (
                                    <span style={{
                                      display: 'inline-block',
                                      animation: orderLists.isDelivered ? 'none' : 'shake 0.5s ease-in-out infinite'
                                    }}>
                                      <NotificationsActiveIcon sx={{
                                        color: "red",
                                      }} fontSize="small" />
                                    </span>
                                  )}
                                </div>

                                <div style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: '#606060',
                                  lineHeight: '1',
                                  textAlign: "left"
                                }}>
                                  {orderLists.orderType}
                                </div>
                                {orderLists.orderTakenById && members.length && (
                                  <span style={{
                                    fontSize: "12px",
                                    padding: '2px',
                                    textAlign: 'left'
                                  }}>
                                    Cashier: <b>{userData.sub == orderLists.orderTakenById ? userData.firstName : members.filter(mb => mb.id == orderLists.orderTakenById)[0]?.firstName}</b>
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Right Side  */}
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end',
                              gap: '6px',
                              textAlign: 'right',
                              '@media (max-width: 768px)': {
                                alignItems: 'flex-start',
                                textAlign: 'left'
                              }
                            }}>
                              {/* Payment Status */}
                              {!orderLists.isPaid ? (
                                <span><Chip
                                  label={"Unpaid /" + orderLists.paymentType}
                                  style={{
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    background: "#fdd564",
                                    color: "#6f650e",
                                  }}
                                /></span>
                              ) : (
                                <Chip
                                  label="✔ PAID"
                                  color="success"
                                  style={{
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                  }}
                                />
                              )}

                              {/* Order Source */}
                              <div style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: '#1976d2',
                              }}>
                                {orderLists.orderSource || "Self Order"}
                              </div>

                              {/* Date & Time */}
                              <div style={{
                                fontSize: "12px",
                                color: '#666',
                              }}>
                                {moment(orderLists.scheduleDate || orderLists.createdAt).format("DD-MMM h:mm a")}
                              </div>

                            </div>
                          </div>

                          {/* Customer Address & Details */}

                          {((orderLists.customerInfo && (orderLists.customerInfo.firstName || orderLists.customerInfo.phone || orderLists.customerInfo.email)) || orderLists.driverDetails) && (
                            <div style={{
                              margin: '8px 0',
                              padding: '12px',
                              background: '#f0f8ff',
                              borderRadius: '8px',
                              border: '1px solid #d1e7ff',
                              flexShrink: 0
                            }}>
                              {/* Common Expand/Collapse Header */}
                              <div
                                onClick={() => setInfoExpanded(prev => ({
                                  ...prev,
                                  [orderLists._id]: !prev[orderLists._id]
                                }))}
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  color: '#1976d2',
                                  marginBottom: '8px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  borderBottom: '1px solid #d1e7ff',
                                  paddingBottom: '4px'
                                }}
                              >
                                {infoExpanded[orderLists._id] !== false ? <ExpandLessIcon style={{ fontSize: '16px' }} /> : <ExpandMoreIcon style={{ fontSize: '16px' }} />}
                                More Information
                              </div>

                              <Collapse in={infoExpanded[orderLists._id] !== false}>
                                <div>
                                  {/* Customer Info */}
                                  {orderLists.customerInfo && (orderLists.customerInfo.firstName || orderLists.customerInfo.phone || orderLists.customerInfo.email) && (
                                    <div style={{ marginBottom: orderLists.driverDetails ? '8px' : '0' }}>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        marginBottom: '4px'
                                      }}>
                                        Customer
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        <b>Name:</b>{` ${orderLists.customerInfo.firstName} ${orderLists.customerInfo.lastName} `}
                                        <b>Phone:</b>
                                        {` ${orderLists.customerInfo.phone} `}
                                        <b>Email:</b>{` ${orderLists.customerInfo.email} `}
                                        <b>Address: </b>{` ${orderLists.customerInfo.address} `}
                                      </div>
                                    </div>
                                  )}

                                  {/* Driver Details */}
                                  {orderLists.driverDetails && (
                                    <div>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#d32f2f',
                                        marginBottom: '4px'
                                      }}>
                                        Driver
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        <b>Name: </b>{` ${orderLists.driverDetails.name}`} <b>Phone:</b>{` ${orderLists.driverDetails.phone}`} <b>Note:</b> {` ${orderLists.driverDetails.notes} `}
                                        <b>Delivery Status:</b> {orderLists.deliveryDetails.driverAssignments.filter(OrdDel => OrdDel.orderDeliveryId == orderLists.deliveryDetails._id)[0].status}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </Collapse>
                            </div>
                          )}


                          {/* Order Items Section  */}
                          <div style={{
                            margin: '12px 0',
                            display: 'flex',
                            flexDirection: 'column'
                          }}>
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}>
                              {/* Order Items Header with Served Items inline */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '10px',
                                borderBottom: '1px solid #dee2e6',
                                flexShrink: 0,
                                paddingBottom: "5px"
                              }}>
                                <strong style={{
                                  fontSize: '15px',
                                }}>
                                  Items ({orderLists.orderItems?.length || 0})
                                </strong>

                                {/* Server Information */}
                                {orderLists.servedByMemeberId && members.length && (
                                  <span style={{
                                    fontSize: "12px",
                                    padding: '2px',
                                  }}>
                                    Serving: <b>{userData.sub == orderLists.servedByMemeberId ? userData.firstName : members.filter(mb => mb.id == orderLists.servedByMemeberId)[0]?.firstName}</b>
                                  </span>
                                )}

                                {(totalItems > 0 && servedItems != totalItems) ? (
                                  <div style={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: '#e65100',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    display: 'inline-block'
                                  }}>
                                    {servedItems}/{totalItems} served
                                  </div>
                                ) : <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <Chip
                                    label="✔ DELIVERED"
                                    color="success"
                                    style={{
                                      fontSize: "x-small",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </div>}
                              </div>

                              {/* Items Container */}
                              <div style={{
                                paddingRight: '4px'
                              }}>
                                {orderLists.orderItems?.map((item, index) => {
                                  let orderItem = item;
                                  const subProArray =
                                    typeof orderItem.sub_pro === "string"
                                      ? JSON.parse(orderItem.sub_pro)
                                      : orderItem.sub_pro;

                                  const subProNames = Array.isArray(subProArray?.addons)
                                    ? subProArray.addons.map((subPro) => subPro.name)
                                    : [];

                                  const subProInstruction = Array.isArray(
                                    subProArray?.cookInstructions
                                  )
                                    ? subProArray.cookInstructions
                                    : [];

                                  const subProVariety =
                                    subProArray?.variety &&
                                      typeof subProArray.variety === "object"
                                      ? Object.keys(subProArray.variety)[0] || ""
                                      : "";

                                  return <div key={index} style={{
                                    marginBottom: '6px',
                                    fontSize: '14px',
                                    padding: '8px',
                                    background: '#fff',
                                    borderRadius: '6px',
                                    border: '1px solid #e9ecef',
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      marginBottom: '4px'

                                    }}>
                                      {/* Item Name  */}
                                      <span style={{
                                        flex: 1,
                                        fontWeight: 'normal',
                                        fontSize: '14px',
                                        textAlign: "left",
                                        lineHeight: '1.4',
                                      }}>
                                        {item.quantity}x {item.name}
                                      </span>
                                      <Chip
                                        label={subProVariety.toUpperCase()}
                                        color="warning"
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "10px",
                                          fontWeight: "bold",
                                        }}
                                      />
                                      {subProNames.length > 0 ? (
                                        <Chip
                                          label={subProNames.join(", ").toUpperCase()}
                                          color="default"
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      ) : (
                                        subProNames
                                      )}
                                      <Chip
                                        label={subProInstruction.join(", ").toUpperCase()}
                                        color="primary"
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "8px",
                                          fontWeight: "bold",
                                        }}
                                      />

                                      {item.appliedOfferDescription && (
                                        <Chip
                                          label={item.appliedOfferDescription.toUpperCase()}
                                          color="info"
                                          variant="outlined"
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                            borderColor: "#1976d2",
                                            color: "#1976d2"
                                          }}
                                        />
                                      )}
                                      {item.status === "ready" || item.status === "delivered" ? <Chip
                                        label="✔"
                                        color={item.status == "ready" ? "warning" : "success"}
                                        style={{
                                          fontSize: "15px!important",
                                          fontWeight: "bold",
                                        }}
                                      /> : (merchantData?.bizVertical === 'restaurant' && <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        minWidth: '80px',
                                        justifyContent: 'flex-end',
                                        marginLeft: '8px',
                                      }}>
                                        <img
                                          src="./chef.gif"
                                          alt="In Progress"
                                          style={{
                                            width: '28px',
                                            height: '28px'
                                          }}
                                        />
                                      </div>)}
                                    </div>
                                  </div>
                                })}
                              </div>

                              {/* Total Section */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '12px',
                                paddingTop: '12px',
                                borderTop: '2px solid #dee2e6',
                                fontWeight: 'bold',
                                fontSize: '15px',
                                flexShrink: 0,
                              }}>
                                <span>Total:</span>
                                <span> {formatter.format(orderLists.totalPrice).replace('JMD', 'J$')} </span>
                              </div>
                            </div>
                          </div>
                          {/* Action Buttons */}
                          <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '16px',
                            paddingTop: '16px',
                            borderTop: '1px solid #eee'
                          }}>
                            {/* Status Section */}


                            {/* First Row - Core Actions */}
                            <div style={{
                              display: 'flex',
                              gap: '13px',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              justifyContent: 'space-around'
                            }}>
                              <div style={{
                                display: 'flex',
                                gap: '13px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                                {!orderLists.isPaid && !orderLists.isCanceled && (
                                  <>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      size="small"
                                      onClick={() => (setSelectedOrder(orderLists), handleUpdateOrder(orderLists))}
                                      startIcon={<EditIcon />}
                                      style={{
                                        fontWeight: '500',
                                        minWidth: '70px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Edit
                                    </Button>

                                    <Button
                                      variant="contained"
                                      color="error"
                                      size="small"
                                      onClick={(e) => {
                                        setPayModeSelectDialog(true);
                                        setSelectedOrder(orderLists);
                                      }}
                                      style={{
                                        fontWeight: 'bold',
                                        minWidth: '85px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Pay Now
                                    </Button>
                                  </>
                                )}

                                <Button
                                  variant="outlined"
                                  color="success"
                                  size="small"
                                  onClick={() => handlecheckprint(orderLists)}
                                  startIcon={<PrintIcon />}
                                  style={{
                                    fontWeight: '500',
                                    minWidth: '70px',
                                    fontSize: '0.7rem',
                                    height: '32px',
                                    padding: '4px 8px'
                                  }}
                                >
                                  Bill
                                </Button>

                                {merchantData?.bizVertical === "restaurant" && !orderLists.orderItems.every(item => item.status === "ready") && <Button
                                  variant="outlined"
                                  color="info"
                                  size="small"
                                  onClick={() => handlecheckprintKOT(orderLists)}
                                  startIcon={<PrintIcon />}
                                  style={{
                                    fontWeight: '500',
                                    minWidth: '90px',
                                    fontSize: '0.7rem',
                                    height: '32px',
                                    padding: '4px 8px'
                                  }}
                                >
                                  KOT
                                </Button>}
                              </div>

                              {/* Right Side  */}
                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                                {/* Discount Button */}
                                {!orderLists.isPaid && !orderLists.isCanceled && (
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    onClick={() => handleOpenPopup(orderLists)}
                                    startIcon={<DiscountIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '110px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Discount
                                  </Button>
                                )}

                                {/* Cancel/Refund Button */}
                                {!userData?.isIAM && !orderLists.isDelivered && !orderLists.isCanceled && (
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    onClick={() => handleCancel(orderLists.id, orderLists.isCanceled, orderLists.tableId, orderLists.number)}
                                    startIcon={<CancelIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '85px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    {orderLists.isPaid ? "Refund" : "Cancel"}
                                  </Button>

                                )}
                                {orderLists.orderType === "Delivery" && orderLists.orderItems.every(item => item.status === "ready") && orderLists.orderStatus.toUpperCase() !== "ASSIGNED" && (
                                  <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    onClick={() => handleAssignDriverClick(orderLists)}
                                    startIcon={<DeliveryDiningIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '115px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Assign Driver
                                  </Button>
                                )}

                                {orderLists.orderType === "Table Order" && (
                                  <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    onClick={() => handleAssignServerClick(orderLists)}
                                    startIcon={<DinnerDining />}
                                    style={{
                                      fontWeight: '500',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Server
                                  </Button>
                                )}
                              </div>
                            </div>

                            {/* Second Row  */}
                            <div style={{
                              display: 'flex',
                              gap: '10px',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              justifyContent: 'space-between'
                            }}>
                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                              </div>

                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>




                                {/* Cancelled Status */}
                                {orderLists.isCanceled && (
                                  <Chip
                                    label="CANCELLED"
                                    color="error"
                                    style={{
                                      fontSize: "x-small",
                                      fontWeight: "bold",
                                      minWidth: '85px',
                                      height: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px',
                    gridColumn: '1 / -1',
                    background: '#f8f9fa',
                    borderRadius: '12px',
                    border: '1px dashed #dee2e6'
                  }}>
                    <h5 style={{ color: '#6c757d', margin: 0 }}>No data available for this date</h5>
                  </div>
                )}
              </div>
            ) : (
              // Table View for Main Orders 
              <Table breakPoint={700} style={{ width: "100%" }}>
                <Thead>
                  <Tr>
                    <Th>#Token</Th>
                    <Th>Source</Th>
                    <Th>Amount (Inc Tax)</Th>
                    <Th>Order Items</Th>
                    <Th></Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {filteredOrders.length ? (
                    (isReversed ? filteredOrders.slice().reverse() : filteredOrders).map((orderLists, index) => {
                      let paidStaus = notifiData.filter((nof) => orderLists.number === nof.token);
                      let payStatus = paidStaus.length ? true : false;
                      let tableCall = false;

                      if (orderLists.orderSource === "Table Order") {
                        const table = tableData && tableData.filter((tab) => tab.number == orderLists.number);
                        tableCall = table ? table[0] ? table[0].isServiceCall : "" : "";
                      }

                      return (
                        <Tr
                          style={
                            orderLists.isCanceled === true
                              ? {
                                backgroundColor: "#fbe3e3cc",
                                borderBottom: "1px solid #f0eeee",
                                margin: "5px",
                              }
                              : {
                                borderBottom: "1px solid #f0eeee",
                                margin: "5px",
                                backgroundColor: "#fff",
                                borderRadius: "8px"
                              }
                          }
                        >
                          <Td
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#4d4a4a",
                            }}
                          >
                            {orderLists.number}
                            <br />
                            {tableCall && (
                              <span
                                className={orderLists.isDelivered ? "" : "shaking-icon"}
                                style={{
                                  display: "inline-block",
                                  fontSize: "9px",
                                  fontWeight: "bold",
                                  left: "35px",
                                }}
                              >
                                <NotificationsActiveIcon sx={{ color: "red" }} fontSize="small" />
                              </span>
                            )}

                            {orderLists.orderType.toLowerCase() === "eat in" && (
                              <img height="40px" alt="" width="40px" src="/images/eat_in.png" />
                            )}
                            {(orderLists.orderType.toLowerCase() === "take away" ||
                              orderLists.orderType.toLowerCase() === "pick up") && (
                                <img height="40px" width="40px" alt="" src="/images/take-out-2.png" />
                              )}
                            {orderLists.orderType === "Table Order" && (
                              <img height="40px" width="40px" alt="" src="/images/tableOrder.png" />
                            )}
                            {orderLists.orderType.toLowerCase() === "delivery" && (
                              <DeliveryDiningIcon style={{ height: "30px", width: "30px" }} />
                            )}
                          </Td>
                          <Td>
                            <Chip
                              label={orderLists.orderSource || "Self Order"}
                              color={
                                (orderLists.orderSource || "Self Order") === "EPOS"
                                  ? "info"
                                  : (orderLists.orderSource || "Self Order") === "Self Order"
                                    ? "warning"
                                    : (orderLists.orderSource || "Self Order") === "Table Order"
                                      ? "secondary"
                                      : (orderLists.orderSource || "Self Order") === "Online Order"
                                        ? "error"
                                        : "default"
                              }
                              style={{
                                marginLeft: "10px",
                                fontSize: "x-small",
                                fontWeight: "bold",
                              }}
                            />
                            <div style={{ fontSize: "12px" }}>
                              {moment(orderLists.scheduleDate || orderLists.createdAt).format("DD-MMM h:mm a")}
                            </div>
                          </Td>

                          <Td>
                            {selectedCurrency}
                            {(orderLists.totalPrice).toFixed(2)}

                            {!orderLists.isPaid ? (
                              <Chip
                                label="PENDING"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                  background: "#fdd564",
                                  color: "#6f650e",
                                }}
                              />
                            ) : (
                              <Chip
                                label="✔ PAID"
                                color="success"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                }}
                              />
                            )}
                          </Td>

                          <Td style={{ fontSize: "12px" }}>
                            <button
                              className="btn-icon"
                              onClick={() =>
                                orderListHandler(
                                  orderLists.id,
                                  orderLists.customerId,
                                  orderLists
                                )
                              }
                            >
                              <ReceiptLongOutlinedIcon />
                            </button>
                            {members.length && orderLists.servedByMemeberId ? (
                              <div>{'Serve by: ' + members.filter(mb => mb.id == orderLists.servedByMemeberId)[0].firstName}</div>
                            ) : ""}
                          </Td>
                          <Td>
                            <div style={{ display: "flex" }}>
                              {orderLists.orderItems?.every((item) => item.status === "delivered") ? (
                                <Chip
                                  label="✔ DELIVERED"
                                  color="success"
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : (
                                merchantData?.bizVertical === 'restaurant' ? (
                                  <img style={{ width: "50px" }} src="./chef.gif" alt="Preparing" />
                                ) : null
                              )}
                              {!orderLists.isPaid && !orderLists.isCanceled && (
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={(e) => {
                                    setPayModeSelectDialog(true);
                                    setSelectedOrder(orderLists);
                                  }}
                                  style={{
                                    display: orderLists.isPaid ? "none" : "inline-block",
                                    cursor: "pointer",
                                    margin: "0px 10px",
                                  }}
                                >
                                  Pay Now
                                </Button>
                              )}
                            </div>
                          </Td>
                          <Td>
                            <div className="actions-container" style={{ position: "relative" }}>
                              {!orderLists.isCanceled && (
                                <Button
                                  style={{ marginRight: "10px" }}
                                  aria-controls={
                                    openActions && selectedOrder?.id === orderLists.id
                                      ? `actions-menu-${orderLists.id}`
                                      : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={
                                    openActions && selectedOrder?.id === orderLists.id
                                      ? "true"
                                      : "false"
                                  }
                                  variant="outlined"
                                  onClick={(event) => {
                                    if (openActions && selectedOrder?.id === orderLists.id) {
                                      setOpenActions(false);
                                    } else {
                                      setSelectedOrder(orderLists);
                                      const buttonElement = event.currentTarget;
                                      const buttonRect = buttonElement.getBoundingClientRect();
                                      const spaceBelow = window.innerHeight - buttonRect.bottom;
                                      const dropdownHeight = 200;
                                      const spaceAbove = buttonRect.top;

                                      if (spaceBelow < dropdownHeight) {
                                        setDropdownPosition("up");
                                      } else {
                                        setDropdownPosition("down");
                                      }
                                      setOpenActions(true);
                                    }
                                  }}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  Actions
                                </Button>
                              )}

                              {openActions && orderLists.id === selectedOrder.id && (
                                <ClickAwayListener
                                  onClickAway={() => setOpenActions(false)}
                                  touchEvent="touchstart"
                                >
                                  <Paper
                                    id={`actions-menu-${orderLists.id}`}
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      zIndex: "99",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      minWidth: "150px",
                                      backgroundColor: "white",
                                      border: "1px solid #ddd",
                                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                      ...(dropdownPosition === "down"
                                        ? { top: "100%" }
                                        : { bottom: "100%" }),
                                    }}
                                  >
                                    <MenuList>
                                      {!orderLists.isPaid && !orderLists.isCanceled && (
                                        <MenuItem
                                          onClick={() => (setOpenActions(false), handleOpenPopup(orderLists))}
                                        >
                                          <DiscountIcon />
                                          Add Discount
                                        </MenuItem>
                                      )}
                                      {!orderLists.isPaid && (
                                        <MenuItem
                                          onClick={() => (setOpenActions(false), handleUpdateOrder(orderLists))}
                                        >
                                          <EditIcon />
                                          Update Order
                                        </MenuItem>
                                      )}
                                      <MenuItem
                                        onClick={() => (handlecheckprint(orderLists), setOpenActions(false))}
                                      >
                                        <PrintIcon color="success" />
                                        Print Order
                                      </MenuItem>
                                      {merchantData?.bizVertical === "restaurant" && <MenuItem
                                        onClick={() => (handlecheckprintKOT(orderLists), setOpenActions(false))}
                                      >
                                        <PrintIcon color="success" />
                                        KOT
                                      </MenuItem>}

                                      {!userData?.isIAM && !orderLists.isDelivered && !orderLists.isCanceled && (
                                        <MenuItem
                                          onClick={() => (
                                            setOpenActions(false),
                                            handleCancel(
                                              orderLists.id,
                                              orderLists.isCanceled,
                                              orderLists.tableId,
                                              orderLists.number
                                            )
                                          )}
                                        >
                                          <CancelIcon color="error" />
                                          {orderLists.isPaid ? "Refund" : "Cancel"}
                                        </MenuItem>
                                      )}
                                      {orderLists.orderType === "Delivery" &&
                                        orderLists.isPaid &&
                                        orderLists.orderItems.every((item) => item.status === "ready") && (
                                          <MenuItem
                                            onClick={() => handleAssignDriverClick(orderLists)}
                                          >
                                            <DeliveryDiningIcon color="success" />
                                            Assign Driver
                                          </MenuItem>
                                        )}

                                      {orderLists.orderType === "Table Order" && (
                                        <MenuItem
                                          onClick={() => handleAssignServerClick(orderLists)}
                                        >
                                          <DinnerDining color="success" />
                                          Server
                                        </MenuItem>
                                      )}
                                    </MenuList>
                                  </Paper>
                                </ClickAwayListener>
                              )}

                              {orderLists.isCanceled && (
                                <Chip
                                  label="CANCELLED"
                                  color="error"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </div>
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <div className="">
                      <h5 className="">No data available for this date</h5>
                    </div>
                  )}
                </Tbody>
              </Table>
            )}
          </div>

          {confirmRejectTempOrder && (
            <DeleteDiaologue
              msg="reject"
              open={confirmRejectTempOrder}
              onClose={() => {
                setConfirmRejectTempOrder(false);
                setTempOrderToRejectId(null);
              }}
              onConfirm={async () => {
                await rejectOrder(tempOrderToRejectId);
                setConfirmRejectTempOrder(false);
                setTempOrderToRejectId(null);
              }}
            />
          )}

          <style jsx>{`
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-2px); }
      75% { transform: translateX(2px); }
    }
    
    .shaking-icon {
      animation: shake 0.5s ease-in-out infinite;
    }
    
    .custom-scrollbar::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    
    .custom-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
    }
  `}</style>
        </div>

      </div>

      {/* Bill Popup */}
      <BillPopup
        open={billPopupOpen}
        onClose={handleClosePopup}
        billDetails={billDetails}
      />

      <AssignDriverPopup
        open={selectedOrderForDriver && assignPopupOpen}
        onClose={() => (setAssignPopupOpen(false), fetchOrdersAndNoti())}
        onAssign={handleDriverAssign}
        authApi={authApi}
        userToken={userToken}
        userid={userData?.sub}
      />

      <AssignWaiterPopup
        open={selectedOrderForServer && assignPopupOpen}
        onClose={() => (setAssignPopupOpen(false), fetchOrdersAndNoti())}
        onAssign={handleWaiterAssign}
        authApi={authApi}
        userToken={userToken}
        userid={userData?.sub}
      />

      <Dialog
        className="dialog-box"
        maxWidth="md"
        fullWidth={true}
        open={isOpen}
      >
        <DialogTitle style={{ fontWeight: "bold" }}>
          {t({ id: "order_summary_token" })}: #
          <span style={{ fontSize: "35px" }}>{token}</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <div
            style={
              customerorderpop
                ? {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  gap: "10px",
                }
                : { display: "none" }
            }
          >
            <h5>
              {t({ id: "name" })}: <span>{customerData.firstName}</span>
            </h5>
            <h5>
              {t({ id: "mobile_no" })}: <span>{customerData.phone}</span>
            </h5>
            <h5>
              {t({ id: "address" })}: <span>{customerData.address}</span>
            </h5>
          </div>
          <Table breakPoint={700} style={{ width: "100%", textAlign: "left" }}>
            <Thead>
              <Tr>
                <Th>{t({ id: "name" })}</Th>
                <Th>{t({ id: "quantity" })}</Th>
                {/* <th>Action</th> */}
              </Tr>
            </Thead>
            <tbody style={{ textAlign: "left !important" }}>
              {orderItemsList.length
                ? orderItemsList.map((orderItem) => {
                  console.log(orderItem);
                  const subProArray =
                    typeof orderItem.sub_pro === "string"
                      ? JSON.parse(orderItem.sub_pro)
                      : orderItem.sub_pro;
                  console.log(subProArray);
                  const subProNames = Array.isArray(subProArray?.addons)
                    ? subProArray.addons.map((subPro) => subPro.name)
                    : [];

                  const subProInstruction = Array.isArray(
                    subProArray?.cookInstructions
                  )
                    ? subProArray.cookInstructions
                    : [];

                  const subProVariety =
                    subProArray?.variety &&
                      typeof subProArray.variety === "object"
                      ? Object.keys(subProArray.variety)[0] || ""
                      : "";


                  return (
                    <Tr id="trow">
                      <Td>
                        <b>{orderItem.name}</b> <br />{" "}
                        {subProNames.length > 0 ? (
                          <Chip
                            label={subProNames.join(", ").toUpperCase()}
                            color="primary"
                            style={{
                              marginLeft: "10px",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          />
                        ) : (
                          subProNames
                        )}
                        <Chip
                          label={subProInstruction.join(", ").toUpperCase()}
                          color="primary"
                          style={{
                            marginLeft: "10px",
                            fontSize: "8px",
                            fontWeight: "bold",
                          }}
                        />
                        <Chip
                          label={subProVariety.toUpperCase()}
                          color="primary"
                          style={{
                            marginLeft: "10px",
                            fontSize: "10px",
                            fontWeight: "bold",
                          }}
                        />
                        {orderItem.appliedOfferDescription && (
                          <Chip
                            label={orderItem.appliedOfferDescription.toUpperCase()}
                            color="info"
                            style={{
                              marginLeft: "10px",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          />
                        )}
                      </Td>
                      <Td>
                        {orderItem.select_type === "weight"
                          ? orderItem.quantity >= 1000
                            ? `${(orderItem.quantity / 1000).toFixed(
                              orderItem.quantity % 1000 === 0 ? 0 : 1
                            )} kg`
                            : `${orderItem.quantity} g`
                          : orderItem.quantity}
                      </Td>
                      <Td>
                        {selectedOrd[0].orderType === "Table Order" ||
                          selectedOrd[0].isPaid ? (
                          orderItem.status === "delivered" ? (
                            <span
                              style={{
                                color: "green",
                                fontSize: "small",
                                fontWeight: "bold",
                              }}
                            >
                              {t({ id: "completed" })}
                            </span>
                          ) : orderItem.status === "ready" ? (
                            <Button
                              id="btnserved"
                              variant="contained"
                              color="success"
                              onClick={() =>
                                HandleServed(selectedOrd, orderItem._id)
                              }
                            >
                              {t({ id: "serve" })}
                            </Button>
                          ) : (
                            <Button
                              id="btnready"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                HandleReady(selectedOrd, orderItem._id)
                              }
                            >
                              {t({ id: "ready" })}
                            </Button>
                          )
                        ) : null}
                      </Td>
                    </Tr>
                  );
                })
                : ""}
            </tbody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            style={{ float: "right", marginTop: "8px" }}
            className="btn btn-danger m-2 btn-small"
            onClick={handleClose}
          >
            {t({ id: "close" })}
          </Button>
        </DialogActions>

      </Dialog>

      <Dialog open={edit} maxWidth="xs" className="pd-2" fullWidth={true}>
        <DialogTitle className="text-center  fw-bold">{itemName}</DialogTitle>
        <form onSubmit={(e) => habdleSubmit(e)} className="p-2">
          <label className="fw-bold mx-2">{t({ id: "item_quantity" })}</label>
          <input
            type="number"
            onChange={handleInput}
            value={editQuantity}
            height="20px"
            width="20px"
            className="form-control w-50 mx-2 "
          />

          <button type="submit" className="btn btn-success m-2 save-btn">
            {t({ id: "save" })}
          </button>

          <button
            onClick={() => setEdit(false)}
            className="btn btn-danger btn-xs m-2 "
            variant="outlined"
          >
            {t({ id: "close" })}
          </button>
        </form>
      </Dialog>

      <Dialog
        open={payModeSelectDialog}
        maxWidth="md"
        className="pd-2"
        onClose={() => setPayModeSelectDialog(false)}
      >
        <DialogTitle className="text-center  fw-bold">
          {" "}
          {t({ id: "pay_mode" })}
        </DialogTitle>
        <div style={{ padding: "10px", minWidth: "450px" }}>
          <PaymentOptions
            handlePaymentClick={setPayModeSelectDialog}
            handlePayMode={handlePayment}
            payModeIndx={payModeIndx}
            setPayModeIndx={setPayModeIndx}
            order={selectedOrder}
            userData={merchantData}
            closeParentDialog={() => setPayModeSelectDialog(false)}
          />
          <Button
            variant="outlined"
            color="error"
            style={{ float: "right", marginTop: "8px" }}
            className="btn btn-danger m-2 btn-small"
            onClick={() => setPayModeSelectDialog(false)}
          >
            {t({ id: "close" })}
          </Button>
        </div>
      </Dialog>
      <Dialog
        open={payConfirmDialog}
        style={{ zIndex: 9999999 }}
      >
        <div class="modal-body" style={{ height: "600px" }}>
          <iframe id="txFrame" src={payConfirmDialog} frameborder="0" allowtransparency="true" style={{ width: "100%", height: "100%" }}></iframe>
        </div>
      </Dialog>
    </div>
  );
};

export default OrderList;